import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { Redirect } from 'react-router';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import Well from 'components/Well';
import LargestCol from 'components/LargestCol';
import HostBookingDetailsContainer from 'containers/HostBookingDetailsContainer';
import BackButtonContainer from 'containers/BackButtonContainer';
import ReservationDetailsContainer from 'containers/ReservationDetailsContainer';
import CreateBookingContainer from '../../ReviewAndSubmit/containers/CreateBookingContainer';
import { BOOKING_ENGINE_PAGE_CHANGED } from 'utils/constants';
import { getBookingEnginePath, HOST_BOOKING } from 'utils/routeUtils';
import { isMobileUserAgent } from 'utils/mobile';
import HostRoomOptions from './HostRoomOptions';

const GuestCol = styled(LargestCol)`
  .row {
    margin-bottom: 0;
  }

  *[class*='col-'] {
    display: flex;
    margin-bottom: 1em;
    position: relative;

    & > span {
      position: absolute;
      top: 100%;
      font-size: 0.8em;
    }
  }

  .header-col {
    margin-bottom: 0;
  }

  & > h1,
  & > h2,
  & > p {
    text-align: center;
  }

  & > h1,
  & > h2 {
    font-size: 1.5em;
    margin-bottom: 0;
  }

  .form-check.form-check-inline {
    .custom-control {
      margin-left: 0.5em;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.large}) {
    & > h1,
    & > h2,
    & > p {
      text-align: left;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.large}) {
    padding-bottom: 3em;
    max-width: ${props => props.theme.fullWidth};
  }
`;

const ReservationCol = styled(LargestCol)`
  @media (max-width: ${props => props.theme.breakpoints.large}) {
    max-width: ${props => props.theme.fullWidth};
    margin: ${props => props.theme.center};
  }
`;

export class HostBookingOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false
    };
  }

  componentDidMount() {
    const isMobile = isMobileUserAgent();
    const parentWindow = window.parent;

    if (isMobile) {
      this.handleMobileEvent(isMobile);
      window.addEventListener('mobile', this.handleMobileEvent);
    }

    parentWindow.postMessage(BOOKING_ENGINE_PAGE_CHANGED, '*');
  }

  componentWillUnmount() {
    if (window.removeEventListener) {
      window.removeEventListener('mobile', this.handleMobileEvent);
    }
  }

  handleMobileEvent = mobile => {
    const { isMobile } = this.state;

    if (isMobile !== mobile) {
      this.setState({
        isMobile: mobile
      });
    }
  };

  render() {
    const {
      handleSubmit,
      selectedRoom,
      isAdmin,
      bookingSource,
      property,
      guestInfo,
      firstName,
      lastName,
      page
    } = this.props;

    const { isMobile } = this.state;

    const isHostBooking = bookingSource === HOST_BOOKING;

    if (!selectedRoom) {
      return <Redirect to={getBookingEnginePath('choose-accommodation')} />;
    }

    return (
      <form onSubmit={handleSubmit}>
        <Helmet>
          <title>Host Booking Options</title>
        </Helmet>
        <Row>
          <GuestCol xs="12" lg={isHostBooking ? 5 : 7}>
            <h1>HOST BOOKING OPTIONS</h1>
            {firstName && lastName && (
              <p>
                Booking for {firstName} {lastName}
              </p>
            )}
            <HostRoomOptions property={property} guestInfo={guestInfo} />
            <BackButtonContainer
              className="back-button-middle"
              to={getBookingEnginePath('choose-accommodation')}
            />
          </GuestCol>
          <ReservationCol xs="12" lg={isHostBooking ? 4 : 5}>
            <Well>
              <ReservationDetailsContainer />
            </Well>
            <CreateBookingContainer isMobile={isMobile} page={page} />
          </ReservationCol>
          <LargestCol md="12" lg="3">
            <HostBookingDetailsContainer
              isAdmin={isAdmin}
              isHostBooking={isHostBooking}
              hideGuestInfo={isMobile}
              hideBookYourStay={isMobile}
            />
          </LargestCol>
          <LargestCol xs="12">
            <BackButtonContainer
              className="back-button-bottom"
              to={getBookingEnginePath('choose-accommodation')}
            />
          </LargestCol>
        </Row>
      </form>
    );
  }
}

HostBookingOptions.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  selectedRoom: PropTypes.object,
  property: PropTypes.string,
  isAdmin: PropTypes.bool,
  bookingSource: PropTypes.string
};

export default reduxForm({
  form: 'guestInfo',
  destroyOnUnmount: false
})(HostBookingOptions);
